module.exports = __webpack_public_path__ + "static/media/ic_searchtype_lock.bc21f6b4.svg";